<div class="container">

  <div class="row" [hidden]="loading">
    <div class="col-sm-12 text-center abx-rect-section">
      <div>
        <div class="abx-header-section">
          <div class="abx-header-wrapper">
            <h3 class="abx-header">{{'SelectDocument' | translate}}</h3>
          </div>
          <span class="lead">{{'SelectDocumentDesc' | translate}}</span>
        </div>
        <div class="hidden-xs hidden-sm dragndrop">
          <br />
          <div class="noselect">
            <div class="dropHere" id="dropHere" [ngClass]="dragClass" (click)="openFileBrowser()" abx-drag-enter="dragEnter()" abx-drag-leave="dragLeave()" abx-drag-drop="fileDropped($abxDropFiles)">
              <div></div>
              <div translate-cloak>{{'DropDocHere' | translate}}</div>
            </div>
          </div>
          <table class="abx-or-separator" [hidden]="mobileDevice"><tr><td><span class="abx-or-separator-line"></span></td><td>{{'Or' | translate}}</td><td><span class="abx-or-separator-line"></span></td></tr></table>
        </div>
        <form class="form-inline" id="fileInputForm">
          <input class="form-control d-none" type="file" id="fileInput" (change)="uploadFileFromFileInput()" />
          <button class="btn btn-default btn-upload btn-upload-file" (click)="openFileBrowser()">{{'ClickToSelect' | translate }}</button>
        </form>
        <button class="btn btn-default btn-upload btn-upload-social btn-upload-file" (click)="fetchFromDropbox()"><i class="fa fa-dropbox"></i> {{'ImportFrom' | translate}} Dropbox</button><br />
        <button class="btn btn-default btn-upload btn-upload-social btn-upload-file" (click)="fetchFromGDrive()"><i class="fa fa-google"></i> {{'ImportFrom' | translate}} Google Drive</button><br />
      </div>
    </div>
  </div>

  <br />

  <div class="page-loader" [hidden]="!loading">
    <div class="centered-div-outer">
      <div class="centered-div-middle">
        <div class="centered-div-inner opening-page">
          <div class="loadingFileSpinner"></div>
          <div>{{'Importing' | translate}}…</div>
        </div>
      </div>
    </div>
  </div>

</div>
